import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCli = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.49976 3.12067L6.37907 7.99998L1.49976 12.8793M8.40072 12.8793H14.4999",
		stroke: "currentColor",
		strokeLinecap: "round"
	})
});
export default SvgCli;
